import { defineStore } from 'pinia'

import { IGroup } from '@/interfaces/entities/group'
import { ICreationGroup, IEditionGroup } from '@/interfaces/api/group'

import GroupResource from '@/api/resources/group'
import { useSuccessStore } from './success'
import { AnalyticsEvents, logFirebaseAnalytics } from '@/utils/firebase'

export const useGroupStore = defineStore({
  id: 'group',

  state: () => ({
    groups: [] as IGroup[],
  }),

  getters: {
    listGroups: (state) => state.groups,
  },

  actions: {
    async fetch({ force = false } = {}) {
      if (this.groups.length === 0 || force) {
        try {
          const groups = await GroupResource.getGroups()

          this.groups = groups
        } catch {
          // Erro ao buscar grupos
        }
      }
    },

    async createGroup(newGroup: ICreationGroup) {
      try {
        const createdGroup = await GroupResource.createGroups(newGroup)
        this.groups.push(createdGroup)
        logFirebaseAnalytics(AnalyticsEvents.GROUP.CREATED)
        useSuccessStore().setSuccess(['Grupo criado com sucesso!'])
      } catch {
        // Erro ao criar grupo
      }
    },

    async removeGroup(groupId: number) {
      try {
        await GroupResource.removeGroups(groupId)
        this.groups = this.groups.filter((group) => group.id !== groupId)
        logFirebaseAnalytics(AnalyticsEvents.GROUP.REMOVED)
      } catch {
        // Erro ao remover grupo
      }
    },

    async editGroup(editedGroup: IEditionGroup) {
      try {
        const updatedGroup = await GroupResource.editGroups(editedGroup)
        const index = this.groups.findIndex((group) => group.id === editedGroup.id)
        if (index !== -1) {
          this.groups[index] = updatedGroup
        }
        logFirebaseAnalytics(AnalyticsEvents.GROUP.EDITED)
      } catch {
        // Erro ao editar grupo
      }
    },
  },
})
